export interface BlockedUntilPayload {
  blockedUntil: string | null;
  reason: string;
  ticketReference: string;
}

export function localBlockedUntilToUtc(value: string): string | null {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return null;
  return date
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");
}

export function blockedUntilRetryState(
  previousPayload: string,
  previousKey: string,
  payload: BlockedUntilPayload,
  createKey: () => string
): { requestPayload: string; idempotencyKey: string } {
  const requestPayload = JSON.stringify(payload);
  return {
    requestPayload,
    idempotencyKey:
      previousPayload === requestPayload && previousKey
        ? previousKey
        : createKey()
  };
}

export async function saveAndRefreshBlockedUntil(
  save: () => Promise<unknown>,
  refreshList: () => Promise<boolean>,
  refreshDetails?: () => Promise<boolean>
): Promise<boolean> {
  await save();
  try {
    if (!(await refreshList())) return false;
    return refreshDetails ? await refreshDetails() : true;
  } catch (_) {
    return false;
  }
}
